import { call, put, takeLatest, select } from 'redux-saga/effects';
import CHECKOUT_ACTIONS from '@tcp/core/src/components/features/CnC/Checkout/container/Checkout.action';
import BAG_PAGE_ACTIONS from '@tcp/core/src/components/features/CnC/BagPage/container/BagPage.actions';
import BAG_SELECTORS from '@tcp/core/src/components/features/CnC/BagPage/container/BagPage.selectors';
import { getDynamicLabelValues } from '@tcp/core/src/utils/labels/labelUtilty';
import {
  confirmStartCheckout,
  getUnqualifiedItemsCall as getUnqualifiedItemsCallSaga,
} from '@tcp/core/src/components/features/CnC/BagPage/container/BagPage.saga';
import ADYENPAYMENT_CONSTANTS from './AdyenPayment.constants';
import makeSessionsSetupCall, {
  makePaymentsCall,
} from '../../../../../services/abstractors/CnC/Adyen';
import { validateReduxCache } from '../../../../../utils/cache.util';
import { setAdyenSessionData, setAdyenSetupData } from './AdyenPayment.actions';
import { AddToCartError } from '../../../../features/CnC/AddedToBag/container/AddedToBag.actions';

export function* startAdyenPayments({ payload }) {
  const { data, isBagPage, resolve, reject } = payload;
  try {
    yield call(getUnqualifiedItemsCallSaga);
    const oOSModalOpen = yield call(confirmStartCheckout);
    if (!oOSModalOpen) {
      try {
        const result = yield call(makePaymentsCall, data, isBagPage);
        if (!result.resultCode) {
          reject(new Error('Payment failed'));
          return;
        }
        resolve(result);
      } catch (e) {
        const errorMapping = yield select(BAG_SELECTORS.getErrorMapping);
        const errCode = e.errorCode;
        const errMsg = errorMapping[errCode] || errorMapping.PAYPAL_CC_ERROR_CODE_GENERIC_ERROR;
        yield put(AddToCartError(errMsg));
        yield put(
          CHECKOUT_ACTIONS.setServerErrorCheckout({
            errorMessage: errMsg,
            component: 'PAGE',
            isSubmitOrderError: true,
          })
        );
        reject(e);
      }
    } else {
      yield put(BAG_PAGE_ACTIONS.setPayPalModalActionOOS(true));
      reject(new Error('Out of stock'));
    }
  } catch (error) {
    const errorMapping = yield select(BAG_SELECTORS.getErrorMapping);
    const errCode = error.errorCodes;
    const errMsg = errorMapping[errCode] || errorMapping.PAYPAL_CC_ERROR_CODE_GENERIC_ERROR;
    yield put(AddToCartError(errMsg));

    yield put(
      CHECKOUT_ACTIONS.setServerErrorCheckout({
        errorMessage: errMsg,
        component: 'PAGE',
        isSubmitOrderError: true,
      })
    );
    reject(new Error('Failed to start Adyen payment'));
  }
}

export function* createSession({ payload }) {
  const { isBagPage = false, cacheTTL = 0 } = payload || {};
  try {
    yield put(setAdyenSetupData(null));
    yield put(AddToCartError(null));
    yield put(CHECKOUT_ACTIONS.setServerErrorCheckout({}));
    const result = yield call(makeSessionsSetupCall, isBagPage);
    if (!result || !result.sessionData) {
      const errMsg = getDynamicLabelValues(
        'dynamic.error_messages.lbl_errorMessages_ERR_ADYEN_GENERIC_SESSIONS'
      );
      yield put(
        CHECKOUT_ACTIONS.setServerErrorCheckout({
          errorMessage: errMsg,
          component: 'PAGE',
        })
      );
      yield put(AddToCartError(errMsg));
      throw new Error('Session creation failed: No session data returned');
    }

    yield put(setAdyenSessionData({ ...result, cacheTTL }));
  } catch (error) {
    const errMsg = getDynamicLabelValues(
      'dynamic.error_messages.lbl_errorMessages_ERR_ADYEN_GENERIC_SESSIONS'
    );
    yield put(
      CHECKOUT_ACTIONS.setServerErrorCheckout({
        errorMessage: errMsg,
        component: 'PAGE',
      })
    );
    yield put(AddToCartError(errMsg));
    console.error('Error during session creation:', error);
  }
}

export function* AdyenPaymentSaga() {
  const CachedCreateSession = validateReduxCache(createSession);
  yield takeLatest(ADYENPAYMENT_CONSTANTS.START_ADYEN_PAYMENT, startAdyenPayments);
  yield takeLatest(ADYENPAYMENT_CONSTANTS.CREATE_ADYEN_SESSION, CachedCreateSession);
}

export default AdyenPaymentSaga;
